import {Delete, Get, Post, Put} from "./config";

// Bank Endpoint
export const storeCategory = (params) => Post('categories', params);
export const updateCategory = (id, params) => Put('categories', id, params);
export const fetchCategory = (params) => Get( 'categories', params);
export const fetchCategoryById = (id) => Get( 'categories/' + id);
export const deleteCategoryById = (id, params) => Delete( 'categories/' + id, params);
